class CasesFilters {
  /**
   * Constructor: Cases Filters Constructor.
   */
  constructor(options = {}) {
    // Root
    this._root = options.root;

    // Elements
    this._filters = options.filters;
    this._selects = options.selects;
    this._grid    = options.grid;
    this._message = options.message;

    if (!this._filters) {
      return;
    }

    // Events
    this._onChange = this.filter.bind(this);
    this._resolve  = this.success.bind(this);
    this._reject   = this.failure.bind(this);

    this._selects.map((select) => {
      select.addEventListener('change', this._onChange);
    });
  }


  /**
   * Filter: Filter Cases
   */
  filter(e) {
    const action = this._filters.getAttribute('action');
    const method = this._filters.getAttribute('method');

    // Update Data
    const url = this.toString();

    // Emit Events
    window.Emitter.emit('cases-filtering');

    // Fetch URL
    fetch(url, { method: 'GET', credentials: 'same-origin' })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        }
        this._reject();
      })
      .then(this._resolve)
      .catch(this._reject);
  }


  /**
   * Success: Parse response from Fetch and update DOM accordingly.
   */
  success(response) {
    // Parse Response
    const parser = new DOMParser();
    const DOM = parser.parseFromString(response, 'text/html');

    const grid    = DOM.querySelector('.cases__grid');
    const message = DOM.querySelector('.cases__message');
    
    if (this._message) this._root.removeChild(this._message);
    if (this._grid) this._root.removeChild(this._grid);

    this._grid    = null;
    this._message = null;

    if (grid) {
      this._root.appendChild(grid);
      this._grid = grid;
    }
    else if (message) {
      this._root.appendChild(message);
      this._message = message;
    }

    // Update History
    history.pushState(this.toJson(), '', this.toString());

    // Emit Events
    window.Emitter.emit('cases-updated');
  }


  /**
   * Failure: Throw an error on Fetch failure.
   */
  failure(err) {
    // Throw Error
    throw Error(err);
  }


  /**
   * To String: Convert selects datas into String.
   * 
   * @return {String}
   */
  toString() {
    let action = this._filters.getAttribute('action');
    let data   = '?';

    // Map each select and update string
    this._selects.map((select) => {
      if (select.value.length !== 0) {
        data += `${select.name}=${select.value}&`;
      }
    });

    // Return String
    return action + '/' + data.slice(0, -1);
  }


  /**
   * To JSON: Convert selects datas in Object.
   * 
   * @return {Object}
   */
  toJson() {
    let data = {};

    // Map each select and update string
    this._selects.map((select) => {
      data[select.name] = select.value;
    });

    // Return Object
    return data;
  }
}

export default CasesFilters;


// WEBPACK FOOTER //
// ./src/js/layouts/cases/filters.js